import React from 'react';
import ReactDOM from 'react-dom';
import { Auth0Provider } from "@auth0/auth0-react";
import mixpanel from 'mixpanel-browser';
import { MixpanelProvider } from 'react-mixpanel';
import './index.css';
import App from './App';

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain="projectparrot.us.auth0.com"
      audience="https://readmethis.site"
      scope="openid profile email"
      clientId="iShqKsl2OZ5PHzdHdSht4osHBO9gzUxn"
      cacheLocation="localstorage"
      useRefreshTokens={true}
      redirectUri={window.location.origin}
    >
      <MixpanelProvider mixpanel={mixpanel}>
        <App />
      </MixpanelProvider>,
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
